import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, BookOpen, Users, MessageSquare, Briefcase, ClipboardCheck, FileCheck, Calendar, HelpCircle, Info, LogOut } from 'lucide-react';
const navItems = [{
  name: 'Dashboard',
  path: '/dashboard',
  icon: LayoutDashboard
}, {
  name: 'Onboarding',
  path: '/onboarding',
  icon: ClipboardCheck
}, {
  name: 'Mid-Program Survey',
  path: '/survey',
  icon: FileCheck
}, {
  name: 'Courses',
  path: '/courses',
  icon: BookOpen
}, {
  name: 'Community',
  path: '/community',
  icon: Users
}, {
  name: 'Chat',
  path: '/chat',
  icon: MessageSquare
}, {
  name: 'Advisory',
  path: '/advisory',
  icon: Briefcase
}, {
  name: 'Calendar',
  path: '/calendar',
  icon: Calendar
}, {
  name: 'FAQ',
  path: '/faq',
  icon: HelpCircle
}, {
  name: 'About',
  path: '/about',
  icon: Info
}];
export function Sidebar() {
  const location = useLocation();
  return <div className="w-64 bg-catalyst-black text-white h-screen flex flex-col fixed left-0 top-0 border-r border-catalyst-brown-dark" data-id="element-67">
      <div className="p-6 flex items-center justify-center border-b border-catalyst-brown-dark/50" data-id="element-68">
        <img src="https://cdn.magicpatterns.com/uploads/fhU3kGRUAmhJPAYevpphn9/header-logo.png" alt="BOF Catalyst Logo" className="h-12 object-contain filter brightness-0 invert" data-id="element-69" />
      </div>

      <div className="flex-1 overflow-y-auto py-6 flex flex-col gap-2 px-4" data-id="element-70">
        {navItems.map(item => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        return <Link key={item.name} to={item.path} className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 ${isActive ? 'bg-white/10 text-catalyst-mustard border-l-4 border-catalyst-mustard' : 'text-gray-400 hover:bg-white/5 hover:text-white border-l-4 border-transparent'}`} data-id="element-71">
              <Icon size={20} className={isActive ? 'text-catalyst-mustard' : ''} data-id="element-72" />
              <span className="font-medium text-sm" data-id="element-73">{item.name}</span>
            </Link>;
      })}
      </div>

      <div className="p-4 border-t border-catalyst-brown-dark/50" data-id="element-74">
        <div className="flex items-center gap-3 px-4 py-3 mb-2" data-id="element-75">
          <img src="https://cdn.magicpatterns.com/uploads/kT5n552sA1fwaoDotd154A/WhatsApp_Image_2025-08-14_at_07.51.30_(1).jpg" alt="Spark Station logo" className="w-8 h-8 rounded-full object-cover" data-id="element-76" />
          <div className="flex-1 overflow-hidden" data-id="element-77">
            <p className="text-sm font-medium text-white truncate" data-id="element-78">
              Sarah Jenkins
            </p>
            <p className="text-xs text-gray-400 truncate" data-id="element-79">
              Founder, Spark Station
            </p>
          </div>
        </div>
        <Link to="/login" className="flex items-center gap-3 px-4 py-2 text-gray-400 hover:text-white transition-colors rounded-lg hover:bg-white/5" data-id="element-80">
          <LogOut size={18} data-id="element-81" />
          <span className="font-medium text-sm" data-id="element-82">Sign Out</span>
        </Link>
      </div>
    </div>;
}